/** @jsx jsx */

import {Fragment,useEffect,useState} from 'react'


import Header from './header'
import {jsx,Button,Card} from 'theme-ui'
import Link from '../components/Link'
import './layout.css'
import useSiteMetadata from './hooks/use-site-metadata'
import {useSpring,animated} from 'react-spring'
import MySEO from '../components/seo'


const Layout = ({ children }) =>  {
    const data=useSiteMetadata()
    const props=useSpring({from: {opacity:0},to:{opacity:1},config:{duration:500}})
    const [warn,setWarn] = useState(false)

    useEffect(()=>{
      if(!typeof window) return
      let flag= window.localStorage.getItem("omds")
      if(flag) 
        setWarn(false)
      else
        setWarn(true)  
    },[warn]) 

    useEffect(()=>{
      if(!typeof window) return
     const t=window.localStorage.getItem("theme-ui-color-mode")
     if(t!=="light")
     window.localStorage.setItem("theme-ui-color-mode","light")
    })
  
    function warnung(){
      setWarn(false)
      if(!typeof window) return
      window.localStorage.setItem("omds",'1')
    }

const Meldung=({location})=>{
    if(typeof window !=="undefined" && document.location.pathname!=="/datenschutz")
    return(
      <Card  sx={{p:[2,4],zIndex:200,position:"absolute",left:[3,4,5],color:"white",background:'rgba(0,0,0,1)',minHeight:600,maxWidth:[280,400]}}>
    <h2 sx={{fontSize:[1,2]}}>Unsere Datenschutzbestimmung</h2>
    <p sx={{fontSize:[0,1]}}>Bitte machen Sie sich mit unseren Datenschutzbestimmungen vertraut.
    Wir geben Ihre Daten nicht an Dritte weiter und eruieren und speichern keinerlei Daten,
    die mit Ihnen in Verbindung gebracht werden können. 
    Die Nutzung unserer Webseite gilt als Zustimmung zu unserem Datenschutz.</p>
<Link sx={{color:`white`,p:[0,1]}} to="/datenschutz">Ausführliche Informationen</Link> zu den Bestimmungen unseres Datenschutzes.

 <br/>
 <br/>
    <Button sx={{cursor:`pointer`,height:30,background:`white`,color:`black`,pt:0,pb:2,width:200}} onKeyDown={()=>warnung()} onClick={()=>warnung()}>Ich stimme zu</Button>
      
    
    </Card>   
    
  
   )
   return null
  }
      return(
      <Fragment>
       
       <MySEO title="Startseite von Kulturnetz Oberes Mittelrheintal" description="Startseite und Navigation der Kulturnetzseite K.O.M." />
        <div 
          sx={{
            flex:`1 0`,
             width:`100vw`,
            
            maxWidth: 1300,
            px:[3,4,4,5],
            justifyContent: `flex-start`,
            alignItems:`flex-start`,
           height:`100%`,
          
           
            paddingTop: 0,
          }}
        >
          <header>
          <Header siteTitle={data.title} />
          </header>
       
          {warn && <Meldung/>}
          <animated.div style={props}>
          <main sx={{mt:[3,4]}}>
      
          
      {children}

          
        
         
          </main>
          </animated.div>
          
        </div>
      </Fragment>
  )}



export default Layout
